import React from 'react';
import { Container } from '@material-ui/core';

import css from './Contact.module.css';

import Title from '../UI/Title/Title';
import Address from './Address/Address';
import ContactForm from './ContactForm/ContactForm';
import Section from '../../hoc/Section/Section';

const Contact = (props) => {
    return (
        <div className={css.Contact}>
            <Title>{props.title}</Title>
            <Container>
                <br /><br />
                <Address />
                <br /><br />
            </Container>
            <Section title="Pošaljite upit za više informacija">
                <ContactForm />
            </Section>
        </div>
    );
};

export default Contact;